import FormModal from './pc';

export default FormModal;
